import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRegitrarUsuarioUME } from "./useRegitrarUsuarioUME";

export const useRecuperarContraseña = () => {
  const navigate = useNavigate();
  const [modalExito, setModalExito] = useState(false);
  const [modalFallo, setModalFallo] = useState(false);
  const [redirect, setRedirect] = useState(false);

  const { recuperarContrasenia } = useRegitrarUsuarioUME();

  const onAceptar = () => {
    if(redirect) {
      navigate("/")
      return setModalExito(false);
    }
    return setModalFallo(false);
  };
  const onFinish = async(documento: string, correo: string) => {
    const {data} = await recuperarContrasenia(documento, correo)
    if(data.message === "Success"){
      setModalExito(true);
      setRedirect(true);
    }else {
      setModalFallo(true);
    }
    return data
  };
  return { modalExito, setModalExito, modalFallo, setModalFallo, onAceptar, onFinish };
};
